/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import DialogDefault from "@jumbo/components/JumboDialog/components/DialogDefault";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";
import Stack from "@mui/material/Stack";
import {
  Button,
  Chip,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Rating,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import InsightsIcon from "@mui/icons-material/Insights";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import moment from "moment";
import VendorActivity from "./vendor-activity";
import Div from "@jumbo/shared/Div";
import Loader from "@jumbo/components/Loader";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import AddVendor from "./add-vendor/index";
import ApproveVendor from "./approve-vendor/index";
import { useDispatch, useSelector } from "react-redux";
import {
  markModuleRead,
  fetchUnreadCount,
} from "app/redux/slice/notificationSlice";
import { useSnackbar } from "notistack";
import { userType } from "app/helpers/userType";
import { useNavigate } from "react-router-dom";
import { manageVendorPrice } from "app/routes/constant";
import {
  approveSupplier,
  createSupplier,
  deleteSupplier,
  exportSupplierList,
  getSupplierList,
  getVendorRatingColor,
  rejectSupplier,
  updateSupplier,
} from "app/redux/slice/supplierSlice";
import { downloadListExcel } from "app/helpers/csvExport";
import { createPartyNumber } from "app/redux/slice/partyNumberSlice";
import { getUserList } from "app/redux/slice/userSlice";

const SUPPLIER_STATUS_COLORS = {
  Pending: "warning",
  Approved: "success",
  Rejected: "error",
};

const OfficeVendor = () => {
  const navigate = useNavigate();
  const { isOpen, onClose, onOpen, stageAction, actionProps } = useDisclosure();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { isMA } = userType();

  const [searchText, setSearchText] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [venderOf, setVenderOf] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [loginFilter, setLoginFilter] = useState("All");
  const [downloading, setDownloading] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const supplierData = useSelector((state) => state?.supplier);

  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();

  const {
    isOpen: isApprove,
    onClose: closeApprove,
    actionProps: approveActionProps,
    stageAction: approveStageAction,
  } = useDisclosure();

  const {
    isOpen: isReject,
    onClose: closeReject,
    actionProps: rejectActionProps,
    stageAction: rejectStageAction,
  } = useDisclosure();

  const {
    isOpen: isActivity,
    onClose: closeActivity,
    actionProps: activityActionProps,
    stageAction: activityStageAction,
  } = useDisclosure();

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    // 25, not the shared default of 100. A vendor row is one of the heaviest in
    // the panel - a Rating, several Chips and up to six IconButtons, each with
    // its own ripple machinery - so a hundred of them is thousands of MUI
    // components to mount before the page paints. The rows-per-page dropdown
    // still offers 100 for anyone who wants the long list.
    usePagination({ id: "vendor", pageSize: 25 });
  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission"))
  );

  const [permission, setPermission] = useState({
    createPermission: false,
    updatePermission: false,
    managePricePermission: false,
    deletePermission: false,
  });
  const getPermission = () => {
    if (isMA) {
      setPermission({
        createPermission: true,
        updatePermission: true,
        managePricePermission: true,
        deletePermission: true,
      });
    } else {
      let permissionValue = {
        createPermission: false,
        updatePermission: false,
        managePricePermission: false,
        deletePermission: false,
      };
      const rolePermission = permissionData?.filter((item) => {
        return item?.moduleName?.includes("Vendor") && item;
      });
      rolePermission?.length &&
        rolePermission.forEach(function (num) {
          if (num?.name === "create-supplier") {
            permissionValue.createPermission = true;
          }
          if (num?.name === "delete-supplier") {
            permissionValue.deletePermission = true;
          }
          if (num?.name === "update-supplier") {
            permissionValue.updatePermission = true;
          }
          if (num?.name === "manage-price-supplier") {
            permissionValue.managePricePermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  const columns = [
    { id: "name", label: "Name", sort: true },
    { id: "email", label: "Email", sort: true },
    { id: "mobileNumber", label: "Phone", sort: true },
    { id: "brokerName", label: "Broker", sort: true },
    {
      id: "brokerName",
      label: "Belongs TO",
      minWidth: 130,
      render: (row) => row?.user?.name,
    },
    {
      id: "rating",
      label: "Rating",
      minWidth: 130,
      render: (row) =>
        row?.rating ? (
          <Rating
            value={row.rating}
            max={5}
            readOnly
            size="small"
            sx={{ color: getVendorRatingColor(row.rating) }}
          />
        ) : (
          <Rating value={0} max={5} readOnly size="small" />
        ),
    },
    {
      id: "lastLoginAt",
      label: "App Login",
      minWidth: 150,
      // The question this column exists to answer at a glance: has this vendor
      // ever got into the app? A date means yes; "Never" means no.
      //
      // The detail sits in a native `title` rather than a MUI <Tooltip>: one
      // Tooltip per row means a Popper instance per row, and this table renders
      // a hundred rows at a time. The full history is a click away in Activity
      // anyway, so the hover text does not need to be a styled component.
      render: (row) =>
        row?.lastLoginAt ? (
          <Chip
            size="small"
            color="success"
            label={moment(row.lastLoginAt).format("DD-MM-YYYY")}
            title={`${row.loginCount || 0} login(s) - last ${moment(
              row.lastLoginAt,
            ).format("DD-MM-YYYY hh:mm A")}`}
          />
        ) : (
          <Chip size="small" color="default" label="Never" />
        ),
    },
    {
      id: "status",
      label: "Status",
      minWidth: 110,
      render: (row) => (
        <Chip
          size="small"
          label={row.status || "Pending"}
          color={SUPPLIER_STATUS_COLORS[row.status] || "warning"}
        />
      ),
    },
    {
      id: "actions",
      label: "Actions",
      minWidth: 240,
      align: "center",
      render: (row) => (
        <>
          <IconButton
            title="Activity - login, viewed products, cart"
            onClick={() => activityStageAction(row)}
          >
            <InsightsIcon color="info" />
          </IconButton>
          <IconButton
            disabled={!permission.updatePermission}
            onClick={() => {
              stageAction(row);
            }}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            disabled={!permission.managePricePermission}
            onClick={() => {
              navigate(manageVendorPrice(row?._id));
            }}
          >
            <CurrencyRupeeIcon />
          </IconButton>
          {row.status !== "Approved" && (
            <Tooltip title="Approve">
              <IconButton
                disabled={!permission.updatePermission}
                onClick={() => approveStageAction(row)}
              >
                <CheckCircleIcon color="success" />
              </IconButton>
            </Tooltip>
          )}
          {row.status !== "Rejected" && (
            <Tooltip title="Reject">
              <IconButton
                disabled={!permission.updatePermission}
                onClick={() => rejectStageAction(row)}
              >
                <CancelIcon color="error" />
              </IconButton>
            </Tooltip>
          )}
          <IconButton
            disabled={!permission.deletePermission}
            onClick={() => {
              deleteStageAction(row);
            }}
          >
            <DeleteIcon color={"error"} />
          </IconButton>
        </>
      ),
    },
  ];

  const handleSubmit = async (data) => {
    const newSupplierData = {
      type: data?.type,
      name: data?.name,
      ...(data?.email && { email: data?.email }),
      address: data?.address,
      brokerName: data?.brokerName,
      mobileNumber: data?.mobileNumber,
      deliveryAddress: data?.deliveryAddress,
      userId: data?.userId,
      gst: data?.gst,
      transportId: data?.transportId,
      transportName: data?.transportName,
      // null clears the rating; the backend validation allows null explicitly.
      rating: data?.rating ?? null,
    };

    const isUpdate = Boolean(actionProps?._id);
    const response = await dispatch(
      isUpdate
        ? updateSupplier({ id: actionProps._id, data: newSupplierData })
        : createSupplier(newSupplierData)
    ).unwrap();
    if (response.status === 200) {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "success",
      });
      if (!isUpdate && data.userId && data.mobileNumber) {
        const pnResponse = await dispatch(
          createPartyNumber({
            name: data.name.trim(),
            belongsTo: data.userId,
            city: "",
            phoneNumbers: [data.mobileNumber.trim()],
          })
        ).unwrap();
        if (pnResponse?.status !== 200 && pnResponse?.status !== 201) {
          enqueueSnackbar(
            pnResponse?.data?.responseMessage || "Party number could not be created",
            { variant: "warning" }
          );
        }
      }
      getData();
      onClose();
    } else {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "error",
      });
    }
  };

  const handleApprove = async (data) => {
    const response = await dispatch(
      approveSupplier({ id: approveActionProps._id, userId: data.userId })
    ).unwrap();
    if (response.status === 200) {
      enqueueSnackbar(response.data?.responseMessage, { variant: "success" });
      if (data.userId && approveActionProps?.mobileNumber) {
        const pnResponse = await dispatch(
          createPartyNumber({
            name: approveActionProps.name.trim(),
            belongsTo: data.userId,
            city: "",
            phoneNumbers: [approveActionProps.mobileNumber.trim()],
          })
        ).unwrap();
        if (pnResponse?.status !== 200 && pnResponse?.status !== 201) {
          enqueueSnackbar(
            pnResponse?.data?.responseMessage || "Party number could not be created",
            { variant: "warning" }
          );
        }
      }
      getData();
      closeApprove();
    } else {
      enqueueSnackbar(response.data?.responseMessage, { variant: "error" });
    }
  };

  const RejectVendor = () => {
    dispatch(
      rejectSupplier({ id: rejectActionProps?._id, reason: rejectReason.trim() })
    )
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, { variant: "success" });
          getData();
          setRejectReason("");
          closeReject();
        } else {
          enqueueSnackbar(res.data?.responseMessage, { variant: "error" });
        }
      });
  };

  const DeleteVendor = () => {
    dispatch(deleteSupplier(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  // The filters only - no page/perPage. Shared by the list and the Excel
  // download, so the file can never be filtered differently from the table.
  const activeFilters = () => ({
    search: searchText.trim(),
    ...(venderOf !== "All" && { type: venderOf }),
    ...(statusFilter !== "All" && { status: statusFilter }),
    // yes = has logged in to the app at least once, no = never has.
    ...(loginFilter !== "All" && {
      loggedIn: loginFilter === "Logged In" ? "yes" : "no",
    }),
    ...(orderBy !== "" && { field: orderBy, sort: order === "asc" ? 1 : -1 }),
  });

  const handleDownloadExcel = async () => {
    const total = supplierData?.total || 0;
    if (!total) {
      enqueueSnackbar("There is nothing to download for these filters.", {
        variant: "info",
      });
      return;
    }

    setDownloading(true);
    try {
      const res = await dispatch(
        exportSupplierList({
          ...activeFilters(),
          // Every matching row in a single page: the file is the whole filtered
          // list, not the 25 rows on screen. `page` must be sent - without it
          // this endpoint answers with the cut-down dropdown projection
          // (name/phone/gst only). The spare 200 covers vendors added between
          // the count the table knows and this request.
          page: 1,
          perPage: total + 200,
        }),
      ).unwrap();

      if (res?.status !== 200) {
        enqueueSnackbar(
          res?.data?.responseMessage || "Could not download the Excel file.",
          { variant: "error" },
        );
        return;
      }

      const rows = res.data?.data?.supplierList ?? [];
      if (!rows.length) {
        enqueueSnackbar("There is nothing to download for these filters.", {
          variant: "info",
        });
        return;
      }

      downloadListExcel({
        fileName: `vendor-list-${moment().format("DD-MM-YYYY")}.xlsx`,
        sheetName: "Vendors",
        columns: [
          { header: "Sr No", width: 8, value: (row, index) => index + 1 },
          { header: "Name", width: 28, value: (row) => row?.name },
          { header: "Email", width: 28, value: (row) => row?.email },
          // Text, not a number: a phone number written as a number loses a
          // leading zero and can come out in scientific notation.
          { header: "Phone", width: 16, value: (row) => row?.mobileNumber },
          { header: "Vendor Of", width: 12, value: (row) => row?.type },
          { header: "Broker", width: 20, value: (row) => row?.brokerName },
          { header: "Belongs To", width: 20, value: (row) => row?.user?.name },
          { header: "Rating", width: 9, value: (row) => row?.rating ?? "" },
          { header: "GST", width: 20, value: (row) => row?.gst },
          { header: "Status", width: 12, value: (row) => row?.status || "Pending" },
          {
            header: "App Login",
            width: 14,
            // Same answer the column on screen gives: a date, or "Never".
            value: (row) =>
              row?.lastLoginAt
                ? moment(row.lastLoginAt).format("DD-MM-YYYY")
                : "Never",
          },
          { header: "Total Logins", width: 12, value: (row) => row?.loginCount ?? 0 },
          {
            header: "First Login",
            width: 14,
            value: (row) =>
              row?.firstLoginAt
                ? moment(row.firstLoginAt).format("DD-MM-YYYY")
                : "",
          },
          {
            header: "Approved On",
            width: 14,
            value: (row) =>
              row?.approvedAt ? moment(row.approvedAt).format("DD-MM-YYYY") : "",
          },
          { header: "Address", width: 36, value: (row) => row?.address },
          {
            header: "Delivery Address",
            width: 36,
            value: (row) => row?.deliveryAddress,
          },
          { header: "Transport", width: 22, value: (row) => row?.transportName },
        ],
        rows,
        filters: [
          ["Search", searchText.trim() || "All"],
          ["Vendor Of", venderOf],
          ["Status", statusFilter],
          ["App Login", loginFilter],
          [
            "Sorted by",
            orderBy ? `${orderBy} (${order === "asc" ? "A-Z" : "Z-A"})` : "-",
          ],
          ["Records", rows.length],
          ["Downloaded on", moment().format("DD-MM-YYYY hh:mm A")],
        ],
      });

      enqueueSnackbar(`${rows.length} record(s) downloaded.`, {
        variant: "success",
      });
    } finally {
      setDownloading(false);
    }
  };

  const getData = () => {
    localStorage.setItem("vendor-search", searchText.trim());
    dispatch(
      getSupplierList({
        page: page,
        perPage: rowsPerPage,
        ...activeFilters(),
      })
    );
    // Mark as read whenever list is fetched
    dispatch(markModuleRead("Supplier")).then(() => {
      dispatch(fetchUnreadCount("Supplier"));
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  // Deliberately a layout effect: a plain useEffect runs after the browser has
  // already painted, so opening the tab first painted the whole hundred-row
  // table left over from the last visit - seconds of blocked main thread with
  // no spinner - and only then flipped to the loader. Fetching before paint
  // means the loader is what the first paint shows.
  useLayoutEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  useEffect(() => {
    dispatch(getUserList({ field: "name", sort: 1 }));
  }, []);

  useEffect(() => {
    getPermission();
  }, []);

  return (
    <>
      {supplierData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth>
                      <InputLabel>Vendor Of</InputLabel>
                      <Select
                        name="vendorOf"
                        id="vendorOf"
                        value={venderOf}
                        label="vendorOf"
                        size="small"
                        onChange={(e) => setVenderOf(e.target.value)}
                      >
                        <MenuItem value={"All"}>{"All"}</MenuItem>
                        {["Office", "Mill", "Knitter"].map((val) => {
                          return <MenuItem value={val}>{val}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth>
                      <InputLabel>Status</InputLabel>
                      <Select
                        name="statusFilter"
                        id="statusFilter"
                        value={statusFilter}
                        label="Status"
                        size="small"
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        {["Pending", "Approved", "Rejected"].map((val) => (
                          <MenuItem key={val} value={val}>
                            {val}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth size="small">
                      <InputLabel>App Login</InputLabel>
                      <Select
                        value={loginFilter}
                        label="App Login"
                        size="small"
                        onChange={(e) => setLoginFilter(e.target.value)}
                      >
                        <MenuItem value={"All"}>All</MenuItem>
                        <MenuItem value={"Logged In"}>Logged In</MenuItem>
                        <MenuItem value={"Never"}>Never Logged In</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Vendor List
                </Typography>
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ mt: { xs: 1, md: 0 } }}
                >
                  <LoadingButton
                    onClick={handleDownloadExcel}
                    loading={downloading}
                    startIcon={<FileDownloadIcon />}
                    variant="outlined"
                    // The whole filtered list, not just the page on screen.
                    title="Download every row matching the current filters"
                  >
                    Download Excel
                  </LoadingButton>
                  {permission.createPermission && (
                    <LoadingButton
                      onClick={() => {
                        onOpen();
                      }}
                      type="submit"
                      variant="contained"
                    >
                      Add Vendor
                    </LoadingButton>
                  )}
                </Stack>
              </Stack>
              <Table
                columns={columns}
                rows={supplierData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={supplierData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
          <DialogDefault
            open={isOpen}
            onClose={onClose}
            content={
              <AddVendor
                value={actionProps}
                onClose={onClose}
                handleSubmit={handleSubmit}
              />
            }
            title={actionProps?._id ? "Update Vendor" : "Add Vendor"}
            fullWidth={true}
            maxWidth={"md"}
            actions={<></>}
          />
          <DialogConfirm
            isOpen={isDelete}
            onClose={closeDelete}
            title="Are you sure you want to delete the vendor?"
            onConfirm={DeleteVendor}
            btnLabels={{ cancel: "Cancel", confirm: "Delete" }}
          />
          <DialogDefault
            open={isActivity}
            onClose={closeActivity}
            content={
              <VendorActivity
                vendor={activityActionProps}
                onClose={closeActivity}
              />
            }
            title={`Activity - ${activityActionProps?.name ?? ""}`}
            fullWidth={true}
            // Wider than the other dialogs on purpose - the viewed-products and
            // cart tabs are five and six column tables.
            maxWidth={"lg"}
            actions={<></>}
          />
          <DialogDefault
            open={isApprove}
            onClose={closeApprove}
            content={
              <ApproveVendor
                value={approveActionProps}
                onClose={closeApprove}
                handleSubmit={handleApprove}
              />
            }
            title="Approve Vendor"
            fullWidth={true}
            maxWidth={"sm"}
            actions={<></>}
          />
          <DialogConfirm
            isOpen={isReject}
            onClose={() => {
              setRejectReason("");
              closeReject();
            }}
            title="Are you sure you want to reject this vendor?"
            content={
              <TextField
                fullWidth
                multiline
                rows={2}
                size="small"
                label="Rejection reason (optional)"
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                sx={{ mt: 2 }}
              />
            }
            onConfirm={RejectVendor}
            btnLabels={{ cancel: "Cancel", confirm: "Reject" }}
          />
        </>
      )}
    </>
  );
};

export default OfficeVendor;
